// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:16:56

export default {
  "id": "block-digger",
  "slug": "block-digger",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/7f0e748671a94c48bd50162f299a95be-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/7f0e748671a94c48bd50162f299a95be/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Block Digger",
      "description": "Dig, Click, and Get Rich! In Block Digger, every tap brings you closer to fortune! Smash stones, collect coins and crystals, and upgrade your mine to skyrocket your earnings. Unlock new mines, chase achievements, and build your mining empire. It's easy, fun, and totally addictive—start digging today! ⛏️",
      "instructions": "Tap the screen or click with your mouse to smash stones, earn rewards, and upgrade your mine!",
      "genres": [
        "Adventure"
      ],
      "tags": [
        "clicker",
        "gold",
        "mining",
        "tycoon",
        "upgrade"
      ]
    },
    "zh-CN": {
      "title": "方块挖掘者",
      "description": "挖掘、点击，财富到手！在《方块挖掘者》中，每一次点击都能让你更接近财富！砸碎石头，收集金币和水晶，升级你的矿井以提升收益。解锁新矿井，追逐成就，构建你的采矿帝国。简单、有趣，完全上瘾——今天就开始挖掘吧！⛏️",
      "instructions": "轻触屏幕或点击鼠标，砸碎石头，赚取奖励，升级你的矿场！",
      "genres": [
        "冒险"
      ],
      "tags": [
        "点击器",
        "金币",
        "采矿",
        "大亨",
        "升级"
      ]
    },
    "zh-TW": {
      "title": "阻塊挖掘者",
      "description": "挖、點、致富！在《塊挖礦》中，每一次點擊都讓你更接近財富！擊碎石頭，收集硬幣和水晶，並升級你的礦場以提升你的收入。解鎖新礦場，追求成就，並建立你的礦業帝國。這很容易、很有趣，而且完全上癮——今天開始挖掘吧！⛏️",
      "instructions": "點擊螢幕或使用滑鼠點擊來擊碎石頭，獲得獎勵，並升級你的礦場！",
      "genres": [
        "冒險"
      ],
      "tags": [
        "點擊器",
        "黃金",
        "礦業",
        "經營大亨",
        "升級"
      ]
    },
    "zh-HK": {
      "title": "塊礦者",
      "description": "挖掘、點擊、致富！在《塊礦挖掘者》中，每一次點擊都讓你更接近財富！擊碎石頭，收集硬幣和水晶，升級你的礦場以激增收入。解鎖新礦場，追求成就，建立你的礦業帝國。易玩、有趣、絕對上癮——今起開挖吧！⛏️",
      "instructions": "按鍵幕或用滑鼠點擊以擊碎石頭，贏取獎勵，並升級你的礦場！",
      "genres": [
        "冒險"
      ],
      "tags": [
        "點擊器",
        "黃金",
        "採礦",
        "大亨",
        "升級"
      ]
    },
    "ja": {
      "title": "ブロックダigger",
      "description": "掘り、クリック、そして豊かさを手に入れよう！ブロックダiggerで、タップひとつで富に近づく！石を壊し、コインやクリスタルを集め、あなたの鉱山をアップグレードして収益を急増させよう。新しい鉱山を解禁し、達成を追い求め、採掘王国を築こう。簡単で楽しい、とにかく中毒性のあるゲーム——今すぐ掘り始めよう！⛏️",
      "instructions": "スクリーンをタップしたり、マウスでクリックして石を壊し、報酬を獲得し、あなたの鉱山をアップグレードしましょう！",
      "genres": [
        "アドベンチャー"
      ],
      "tags": [
        "クリッカーゲーム",
        "金",
        "採掘",
        "大企業",
        "アップグレード"
      ]
    },
    "ko": {
      "title": "블록 캘리거",
      "description": "굴라, 클릭하고 부유해지세요! 블록굴리치에서는 هر 번 탭하면 자신의 재산에 한 걸음 더 다가갑니다! 돌을 부수고 동전과 결정을 모으고, 광산을 업그레이드하여 수익을 급격히 높이세요. 새로운 광산을 해금하고 성취를 쟁취하고, 광산 제국을 건설하세요. 쉽고 재미있으며 완전히 중독성이 있는 게임입니다—오늘 바로 시작하세요! ⛏️",
      "instructions": "화면을 탭하거나 마우스로 클릭하여 돌을 깨고 보상을 얻어 광산을 업그레이드하세요!",
      "genres": [
        "모험"
      ],
      "tags": [
        "클릭러",
        "금",
        "광업",
        "타이콘",
        "업그레이드"
      ]
    },
    "fr": {
      "title": "Bûcheron de Blocs",
      "description": "Creuse, clique et deviens riche ! Dans Block Digger, chaque coup de doigt t'approche de la fortune ! Écrase les pierres, collecte des pièces et des cristaux, et améliore ta mine pour augmenter vos gains. Débloque de nouvelles mines, poursuis des accomplissements et construis ton empire minier. C'est facile, amusant et complètement addictif — commence à creuser aujourd'hui ! ⛏️",
      "instructions": "Tapez l'écran ou cliquez avec votre souris pour briser des pierres, gagner des récompenses et améliorer votre mine !",
      "genres": [
        "Aventure"
      ],
      "tags": [
        "clic",
        "or",
        "minage",
        "tycoon",
        "mise à niveau"
      ]
    }
  }
};
